import { gql, useQuery } from "@apollo/client"
import { ENGAGEMENT_EQUITY_GRANTS_FRAGMENT } from "@oysterhr/equity"

/* Remove this when TabBenefits query is updated */
const BENEFITS_CONTRACTOR_SUGGESTED_BENEFITS_FRAGMENT = gql`
  fragment BenefitsContractorSuggestedBenefitsFragment on Employment {
    suggestedBenefitPlans {
      id
      name
      priceEstimate {
        currencies {
          currencyCode
          subunit
        }
      }
      provider {
        name
      }
    }
  }
`

/* Most of this information is being used in EmploymentSwitcher */
const EMPLOYMENT_CONTRACTOR_FRAGMENT = gql`
  fragment EmploymentContractorFragment on Employment {
    company {
      id
      name
    }
    coEmployee {
      id
      name
    }
    benefitsDescription
    countryCode
    createdAt
    documents {
      id
    }
    engagementType
    employerOfRecord {
      id
    }
    id
    invitation {
      name
      sentAt
      usedTokenAt
    }
    lastSubmittedOn
    role
    salaryAmount
    salaryCurrencyCode
    startDate
    state
    # Remove this when TabBenefits query is updated
    ...BenefitsContractorSuggestedBenefitsFragment
  }
`

export const CONTRACTOR_EMPLOYMENT_PAGE_QUERY = gql`
  ${BENEFITS_CONTRACTOR_SUGGESTED_BENEFITS_FRAGMENT}
  ${EMPLOYMENT_CONTRACTOR_FRAGMENT}
  ${ENGAGEMENT_EQUITY_GRANTS_FRAGMENT}
  query ContractorEmploymentPage($engagementId: ID!) {
    engagement(engagementId: $engagementId) {
      createdAt
      engagedAt
      id
      state
      teamMemberName
      contract {
        id
      }
      activeOrPendingSubscription {
        id
        plan {
          id
          name
          product
          billingFrequencyInMonths
        }
        supersededBy {
          id
          plan {
            id
            name
            product
            billingFrequencyInMonths
          }
          startsOn
        }
      }
      company {
        id
      }
      engagementChanges {
        id
      }
      equityGrants {
        ...EngagementEquityGrants
      }
    }
    employment(employmentId: $engagementId) {
      ...EmploymentContractorFragment
    }
  }
`
type useContractorEmploymentPageQueryArgs = { employmentId: string }
export const useContractorEmploymentPageQuery = ({
  employmentId,
}: useContractorEmploymentPageQueryArgs) =>
  useQuery(CONTRACTOR_EMPLOYMENT_PAGE_QUERY, {
    variables: { engagementId: employmentId },
  })
